import ttsMapping from "app/main/ttsMapping.json";
import { ServerResponse } from "http";
import { AssetClass, FundTypeClass } from "../../interfaces/enums";

/**
 * Crafts a url to fetch an instrument with a given ISIN from the API.
 */
export const getInstrumentUrl = (apiURL: string, isin: string) => `${apiURL}/instruments?id=${isin}&idType=ISIN`;

/**
 * Check url for foreign isin (tts-xxxxxx)
 * returns a mapped isin (ttsMapping.json) or empty string
 */
export const mapForeignIsin = (isin: string) => {
    const ttsMap: { [key: string]: string } = ttsMapping;
    isin = isin.replace("isin_", "").toUpperCase();
    if (!isin.startsWith("TTS-")) {
        return isin;
    }
    if (ttsMap[isin]) {
        return ttsMap[isin];
    }
    return "";
};

/**
 * Try to use `serverSideRedirect()` in `getServerSideProps()` instead.
 * @deprecated
 */
export const redirectToUrl = (res: ServerResponse, targetUrl: string, permanent: boolean) => {
    res.writeHead(permanent ? 301 : 302, { location: targetUrl });
    res.end();
};

export const serverSideRedirect = (destination: string, permanent: boolean = false) => ({
    redirect: {
        destination,
        permanent
    }
});

/**
 * Crafts a url to fetch an instrument with a given ID and its apropriate IDType from the API.
 */
export const getInstrumentUrlByID = (apiURL: string, id: string, idType: string) =>
    `${apiURL}/instruments?id=${id}&idType=${idType}`;

/**
 * Crafts a url to fetch an analysis with a given id from the API.
 */
export const getAnalysisDetailUrl = (apiURL: string, analysisId: string) => `${apiURL}/analysis/${analysisId}`;

/**
 * Crafts a url to fetch chart data from.
 */
export const getChartDataUrl = (apiURL: string, chartKey: string, period: string) =>
    `${apiURL}/charts?id=${chartKey}&period=${period}`;

/**
 * Crafts a url to fetch an news with a given id from the API.
 */
export const getNewsDetailUrl = (apiURL: string, newsId: string) => `${apiURL}/news/${newsId}`;

/**
 * Crafts a url to fetch an news with a given id from the API.
 */
export const getLatestNewsUrl = (apiURL: string, offset = 0, limit = 5) =>
    `${apiURL}/news?offset=${offset}&limit=${limit}`;

/**
 * Gets the best performing assets url
 */
export function getBestPerformersUrl(
    apiURL: string,
    assetClass: string,
    period: string,
    region?: string,
    fundTypeClass?: FundTypeClass
): string {
    if (fundTypeClass) {
        return `${apiURL}/bestperformers?assetClass=${assetClass}&period=${period}&fundTypeClass=${fundTypeClass}`;
    } else {
        return `${apiURL}/bestperformers?assetClass=${assetClass}&period=${period}&region=${region}`;
    }
}
